module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLight.woff?560a34dd77f4683038965dad37511c7d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLight.woff
// module id = 1398
// module chunks = 0